<template>
  <SogCard>
    <SogCardTitle>
      {{ props.orderHead.orderNumber }}
    </SogCardTitle>
    <SogCardContent>
      <SogFlexRow class="test">
        <DeliveryCardHeadComponent :order-head="props.orderHead" />
        <DeliveryCardItemComponent
          v-for="item in props.orderItems"
          :key="item"
          :item="item"
        />
      </SogFlexRow>
    </SogCardContent>
    <slot />
  </SogCard>
</template>

<script setup lang="ts">

import OrderHead from "@/shared/model/orderHead";
import SogCard from "@/shared/ui/SogCard.vue";
import SogCardTitle from "@/shared/ui/SogCardTitle.vue";
import SogCardContent from "@/shared/ui/SogCardContent.vue";
import DeliveryCardHeadComponent from "@/modules/Store/components/DeliveryCardHeadComponent.vue";
import OrderItem from "@/shared/model/orderItem";
import DeliveryCardItemComponent from "@/modules/Store/components/DeliveryCardItemComponent.vue";
import SogFlexRow from "@/shared/ui/SogFlexRow.vue";

interface Props {
  orderHead:OrderHead
  orderItems: OrderItem[]
}
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const props = withDefaults(defineProps<Props>(), {
  orderHead:undefined
  }
)




</script>

<style scoped>

.test{
    justify-content: flex-start;
}

</style>
